export function getClipInfo(session, shotId, candidateId) {
  const shots = session?.storyboard?.shot_list || session?.storyboard?.shots || [];
  const shot = shots.find(s => s.id === shotId);
  if (!shot) return null;
  const cand = (shot.candidates || []).find(c => c.id === candidateId);
  if (!cand) return null;
  return {
    video_url: cand.video_url,
    thumbnail_url: cand.thumbnail_url,
    room_name: shot.room_name || shot.room_label || '',
    status: cand.status,
  };
}
